import PropTypes from 'prop-types';
import { campaignActions } from 'core/Campaign';
import { config } from 'config';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
    ButtonFooter,
    Checkbox,
    Container,
    ExpandButton,
    Modal,
    Text
} from 'mol-ui';
import {
    PatientPicker,
    WorkplacePicker
} from 'views/pickers';
import React, { useEffect, useState } from 'react';
import {
    useDispatch,
    useSelector
} from 'hooks';
const { workplaces } = config;

const SINGLE = 'single';
const WORKPLACE = 'workplace';

const InvitationModal = ({
    active = false,
    id,
    onClose = () => null
}) => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { successColor } = useTheme();
    const {
        invitationSuccess,
        processing
    } = useSelector('campaign');

    useEffect(() => {
        dispatch(campaignActions.setCampaignInvitationSuccess(false));
    }, [active]);

    const [invitationType, setInvitationType] = useState(SINGLE);
    const [patientId, setPatientId] = useState(null);
    const [workplaceId, setWorkplaceId] = useState(null);

    const handleParticipantInvitation = () => {
        dispatch(campaignActions.inviteParticipants({
            id,
            ...(invitationType === SINGLE && { patient_id: patientId }),
            ...(invitationType === WORKPLACE && { workplace_id: workplaceId })
        }));
    };

    return (
        <Modal active={ active } width="360px" onClose={ onClose }>
            <Container width="100%">
                <Checkbox
                    radio
                    checked={ invitationType === SINGLE }
                    label={ t('Invitación individual') }
                    margin="0px 0px 10px 0px"
                    onClick={ () => setInvitationType(SINGLE) }
                />
                {
                    invitationType === SINGLE &&
                    <PatientPicker
                        allowNone={ false }
                        value={ patientId }
                        width="100%"
                        onChange={ value => setPatientId(value) }
                    />
                }
                {
                    workplaces &&
                    <>
                        <Checkbox
                            radio
                            checked={ invitationType === WORKPLACE }
                            label={ t('Por lugar de trabajo') }
                            margin="0px 0px 10px 0px"
                            onClick={ () => setInvitationType(WORKPLACE) }
                        />
                        {
                            invitationType === WORKPLACE &&
                            <WorkplacePicker
                                allowNone={ false }
                                margin="0px 0px 20px 0px"
                                value={ workplaceId }
                                width="100%"
                                onChange={ value => setWorkplaceId(value) }
                            />
                        }
                    </>
                }
                {
                    invitationSuccess &&
                    <Text color={ successColor } margin="0px 0px 10px 0px" textAlign="center">
                        { t('Los pacientes fueron agregados a la lista correctamente') }
                    </Text>
                }
            </Container>
            <ButtonFooter margin="10px 0px 10px 0px">
                <ExpandButton
                    danger
                    caption={ invitationSuccess ? t('Volver') : t('Cancelar') }
                    size={ 80 }
                    onClick={ onClose }
                />
                <ExpandButton
                    caption={ t('Agregar') }
                    disabled={ (invitationType === SINGLE && !patientId) || (invitationType === WORKPLACE && !workplaceId) }
                    loading={ processing }
                    size={ 80 }
                    onClick={ handleParticipantInvitation }
                />
            </ButtonFooter>
        </Modal>
    );
};

InvitationModal.propTypes = {
    active: PropTypes.bool,
    id: PropTypes.number,
    onClose: PropTypes.func
};

export default InvitationModal;
